import React, { useState, useContext, useEffect } from 'react';
import {
	Typography,
	TextField,
	Divider,
	Container,
	Button,
	Paper,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Stack
} from '@mui/material';
import Swal from 'sweetalert2';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-regular-svg-icons';
import { DataContext } from '../../../context/DataContext';
import { getToken } from '../../../api/Account';
import { simpleMessage } from '../../../helpers/Helpers';
import { getAllGestoresAsync, getGestoresBySucursalAccessAsync } from '../../../api/Users';
import { changeGestorAsync } from '../../../api/Credits';

const ChangeGestor = ({ setShowModal, id, localReload, setLocalReload, gestorActual }) => {
	const [gestorList, setGestorList] = useState([]);

	const [gestorListDestino, setGestorListDestino] = useState([]);
	const [selectedGestorDestino, setSelectedGestorDestino] = useState('');

	const { reload, setIsLoading, setIsLogged, setIsUnautorized } = useContext(DataContext);

	const token = getToken();

	const getGestoresBySucursal = async () => {
		const result = await getAllGestoresAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setGestorList(result.data.result);
		const filtered = result.data.result.filter((p) => p.id !== gestorActual);
		setGestorListDestino(filtered);
	};

	useEffect(() => {
		getGestoresBySucursal();
	}, []);

	const saveChangesAsync = async () => {
		Swal.fire({
			title: '¿Estas Seguro?',
			text: 'No podras revertir esto...!',
			icon: 'warning',
			showCancelButton: true,

			confirmButtonColor: '#2979ff',
			cancelButtonColor: '#f50057',

			confirmButtonText: 'Guardar Cambios',
			cancelButtonText: 'Cancelar',
			customClass: {
				container: 'my-swal',
				popup: 'border'
			}
		}).then((result) => {
			if (result.isConfirmed) {
				if (validate()) {
					const data = {
						creditId: id,
						gestorId: selectedGestorDestino
					};
					(async () => {
						setIsLoading(true);
						const result = await changeGestorAsync(token, data);
						if (!result.statusResponse) {
							setIsLoading(false);
							if (result.error === 'Unauthorized') {
								setIsUnautorized(true);
								return;
							}
							simpleMessage(result.error, 'error');
							return;
						}
						setIsLoading(false);
						setLocalReload(!localReload);
						Swal.fire({
							title: 'Exito!',
							text: 'Gestor cambiado exitosamente.',
							icon: 'success',
							customClass: { container: 'my-swal', popup: 'border' }
						});
						setShowModal(false);
					})();
				}
			}
		});
	};

	const validate = () => {
		let isValid = true;

		if (selectedGestorDestino.length === 0) {
			simpleMessage('Seleccione un gestor destino', 'error');
			return (isValid = false);
		}

		if (gestorActual === selectedGestorDestino) {
			simpleMessage('Debe seleccionar gestores diferentes', 'error');
			return (isValid = false);
		}
		return isValid;
	};

	return (
		<div>
			<Container style={{ width: 450 }}>
				<Paper
					style={{
						padding: 20
					}}
				>
					<Typography variant="h6" color={'#2979ff'} style={{ textAlign: 'center' }}>
						Gestor Base
					</Typography>

					<FormControl fullWidth style={{ textAlign: 'left' }} disabled>
						<InputLabel id="demo-simple-select-standard-label">Gestor Base</InputLabel>
						<Select
							labelId="demo-simple-select-standard-label"
							id="demo-simple-select-standard"
							value={gestorActual}
							label="Gestor Base"
							style={{ textAlign: 'left' }}
						>
							<MenuItem value="">
								<em>Seleccione un Gestor</em>
							</MenuItem>
							{gestorList.map((item) => {
								return (
									<MenuItem key={item.id} value={item.id}>
										{item.fullName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Paper>

				<hr />

				<Paper
					style={{
						padding: 10
					}}
				>
					<Typography variant="h6" color={'#2979ff'} style={{ textAlign: 'center' }}>
						Gestor Destino
					</Typography>

					<FormControl fullWidth style={{ textAlign: 'left' }}>
						<InputLabel id="demo-simple-select-standard-label">
							Gestor Destino
						</InputLabel>
						<Select
							labelId="demo-simple-select-standard-label"
							id="demo-simple-select-standard"
							onChange={(e) => setSelectedGestorDestino(e.target.value)}
							value={selectedGestorDestino}
							label="Gestor Destino"
							style={{ textAlign: 'left' }}
						>
							<MenuItem value="">
								<em>Seleccione un Gestor</em>
							</MenuItem>
							{gestorListDestino.map((item) => {
								return (
									<MenuItem key={item.id} value={item.id}>
										{item.fullName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Paper>

				<Button
					variant="outlined"
					startIcon={<FontAwesomeIcon icon={faSave} style={{ marginRight: 20 }} />}
					fullWidth
					onClick={() => saveChangesAsync()}
					style={{
						color: '#ffc400',
						borderColor: '#ffc400',
						marginTop: 20
					}}
					size="large"
				>
					Guardar Cambios
				</Button>
			</Container>
		</div>
	);
};

export default ChangeGestor;
